// extracted by mini-css-extract-plugin
module.exports = {"tokens":"fixtureCardFirstSlot_tokens__vAVqV","fixtureCardFirstSlot":"fixtureCardFirstSlot_fixtureCardFirstSlot__ygN_x"};